import { render, staticRenderFns } from "./whois.vue?vue&type=template&id=1abf1b31&scoped=true&"
import script from "./whois.vue?vue&type=script&lang=js&"
export * from "./whois.vue?vue&type=script&lang=js&"
import style0 from "./whois.vue?vue&type=style&index=0&id=1abf1b31&lang=scss&module=true&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1abf1b31",
  null
  
)

export default component.exports